import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IBillingState, BillingActionCreators, IApplicationState, AppActionCreators, ISearchListResponse } from '@nkr/store/index';
import { ISortBy, IBillingDetail, IBaseResponse, ISearchForList } from '@nkr/models/index';
import { Glyphicon } from 'react-bootstrap';
import SearchRow from './search-row';
import { SearchTableWrapper } from '../styles';
import NoData from '../no-data';
import NavDonorCenter from '../nav-donor-center';
import { NavSubWrapper } from '../../styles';
import Filter from './filter';

interface IOwnProps {
    centerId: number,
    centerAlias: string,
    isAccountsReceivable: boolean
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSearchList: (centerId: number, status: number, isAccountsReceivable: boolean) => Promise<ISearchListResponse>,
    markBilledManually: (donorId: number, recipientId: number) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    dateRange: number,
    status: number,
    sortBy: ISortBy,
    billedManually: {
        show: boolean,
        data: IBillingDetail
    }
}

class All extends React.Component<TProps, IState> {
    readonly state: IState = {
        dateRange: 0,
        status: 0,
        sortBy: { property: 'transplantDate', direction: 'asc' },
        billedManually: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    handleDateRangeChange = (dateRange: number) => {
        this.setState({
            dateRange
        });
    }

    handleStatusChange = (status: number) => {
        this.setState({
            status
        });
    }

    handleViewCharges = (donorId: number, action: string) => {
        window.location.href = `/center/${this.props.centerId}/billing/${action}/${donorId}`;
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);

        if (sortBy.property == property) {
            if (sortBy.direction == 'asc') {
                sortBy.direction = 'desc'
            } else {
                if (sortBy.direction == 'desc') {
                    sortBy = { property: '', direction: '' };
                }
            }
        } else {
            sortBy = { property, direction: 'asc' };
        }

        this.setState({
            sortBy
        });
    }

    getData = () => {
        let { status } = this.state;

        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.getSearchList(this.props.centerId, status, this.props.isAccountsReceivable).then(response => {
                this.props.hideLoading();
            });
        });
    }

    getFilteredRows = () => {
        return this.props.billing.search.filter(x => {
            let dateRange = this.state.dateRange > 0 ? moment(x.transplantDate).isAfter(moment().addDays(-1 * this.state.dateRange)) : true;
            let status = this.state.status != 0 ? x.statusId == this.state.status : true;

            return dateRange && status;
        });
    }

    getSortedRows = () => {
        let { property, direction } = this.state.sortBy;
        let filteredRows = this.getFilteredRows();
        let sortedRows: ISearchForList[] = [];

        if (property != '') {
            sortedRows = _.orderBy(filteredRows, item => {
                switch (property) {
                    case 'transplantDate': return parseInt(moment(item.transplantDate).format('YYYYMMDD'));
                    case 'swapNumber': return parseInt(item.chainId + '' + item.clusterNumber + '' + item.positionNumber);
                    case 'donorCenter': return item.donorCenterAlias;
                    case 'donorAlias': return item.donorAlias;
                    case 'recipientAlias': return item.recipientAlias;
                    case 'recipientCenter': return item.recipientCenterAlias;
                }

            }, [direction]);
        } else {
            sortedRows = filteredRows;
        }

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const sortedRows = this.getSortedRows();
        
        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 0px 5px' }}>
                    <NavSubWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                        <NavDonorCenter
                            section={'SEARCH'}
                            tabText={''}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />

                        <Filter
                            dateRange={this.state.dateRange}
                            status={this.state.status}
                            centerAlias={this.props.centerAlias}
                            onDateRangeChange={this.handleDateRangeChange}
                            onStatusChange={this.handleStatusChange}
                        />
                    </NavSubWrapper>

                    {sortedRows.length > 0 ?
                        <SearchTableWrapper bordered condensed striped>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('transplantDate')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>TXP<br />Date</div> {this.renderHeaderSort('transplantDate')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('swapNumber')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Swap #</div> {this.renderHeaderSort('swapNumber')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenter')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Donor<br />Center</div> {this.renderHeaderSort('donorCenter')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorAlias')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Donor<br />Alias</div> {this.renderHeaderSort('donorAlias')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientCenter')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Recipient<br />Center</div> {this.renderHeaderSort('recipientCenter')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientAlias')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Recipient<br />Alias</div> {this.renderHeaderSort('recipientAlias')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('claimType')}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>Claim<br />Type</div> {this.renderHeaderSort('claimType')}
                                        </div>
                                    </th>
                                    <th style={{ cursor: 'pointer' }}>Request<br />Date</th>
                                    <th style={{ cursor: 'pointer' }}>Accept/Reject<br />Deadline</th>
                                    <th style={{ cursor: 'pointer' }}>Accept<br />Date</th>
                                    <th style={{ cursor: 'pointer' }}>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedRows.map((item, index) =>
                                    <SearchRow
                                        key={index}
                                        centerId={this.props.centerId}
                                        data={item}
                                        onViewCharges={this.handleViewCharges}
                                    />
                                )}
                            </tbody>
                        </SearchTableWrapper>
                        :
                        <NoData message={'No invoices found for your center...'} />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSearchList: (centerId, status, isAccountsReceivable) => {
            return dispatch(BillingActionCreators.getSearchList(centerId, status, isAccountsReceivable));
        },
        markBilledManually: (donorId, recipientId) => {
            return dispatch(BillingActionCreators.markBilledManually(donorId, recipientId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(All);